import { atom } from "recoil";
import { TPlot } from "stencil-library";
import { TFarmUser } from "../../services/user.service";

export const selectedPlotState = atom<TPlot | null>({
  key: "selectedPlotState",  
  default: null,  
});

export const userData = atom<TFarmUser | null>({
  key: "userData",  
  default: null,  
});